import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Defect } from './defect.entity';
import { DefectController } from './defect.controller';
import { DefectService } from './defect.service';
import { DefectAdapter } from './dto/defect.adapter';
import { LogsService } from '@gtpl/shared-services/user-logs';


@Module({
  imports: [
    TypeOrmModule.forFeature([Defect]),
  ],
  controllers: [DefectController],
  providers: [DefectService, DefectAdapter, ApplicationExceptionHandler,LogsService]
})
export class DefectModule { }
